export default __webpack_public_path__ + "static/media/ic_selector_dropdowns.5e3eb9d5.svg";